import { getAPIErrorMessage } from 'api';
import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
export const archive_task_update = (archive_tasks) => ({
    type: 'UPDATE_ARCHIVE_TASKS',
    tasks: archive_tasks,
});
export const alien_tokens_update = (alien_tokens) => ({
    type: 'UPDATE_ALIEN_TOKENS',
    tokens: alien_tokens,
});
export const getArchive = (device_id, mintime, maxtime, split_by) => async (dispatch, getState, { api }) => {
    try {
        const { archive_id } = await api.generate_archive(device_id, mintime, maxtime, split_by);
        location.href = api.get_url('download_generated_archive', {
            archive_id,
        }, true);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось запросить архив'),
            error,
        }));
    }
};
export const add_archive_task = (device_id, period) => async (dispatch, getState, { api }) => {
    try {
        await api.add_archive_task(device_id, period);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось добавить задание'),
            error,
        }));
    }
};
export const deleteToken = (token_id) => async (dispatch, getState, { api }) => {
    try {
        await api.delete_alien_token(token_id);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось удалить токен'),
            error,
        }));
    }
};
export const updateTokensInfo = () => async (dispatch, getState, { api }) => {
    const response = await api.get_tokens_info();
    const alien_tokens = response.tokens;
    dispatch(alien_tokens_update(alien_tokens));
};
export const delete_archive_task = (task_id) => async (dispatch, getState, { api }) => {
    try {
        await api.delete_archive_cron_task(task_id);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось удалить архив задание'),
            error,
        }));
    }
};
export const download_archive_to_cloud = (device_id, min_time, max_time, split_by) => async (dispatch, getState, { api }) => {
    try {
        await api.download_archive_to_cloud(device_id, min_time, max_time, split_by);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось загрузить архив в облако'),
            error,
        }));
    }
};
export const updateArchiveTasks = () => async (dispatch, getState, { api }) => {
    try {
        const response = await api.get_task_list();
        const tasks = response.content.tasks;
        dispatch(archive_task_update(tasks));
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось запросить архив'),
            error,
        }));
    }
};
